module.exports = __webpack_public_path__ + "static/media/blueEmail.3e808e8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/blueEmail.svg
// module id = 449
// module chunks = 0